module.exports = __webpack_public_path__ + "static/media/save-share@2x.64630e8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/save-share@2x.png
// module id = 886
// module chunks = 0